export default __webpack_public_path__ + "static/about-our-logo-0da3ba98f5c03e785dc8becdd87b6b45.jpg";